import { RenderingPermissionsDirective } from './rendering-permissions.directive';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';



@NgModule({
  declarations: [RenderingPermissionsDirective],
  imports: [
    CommonModule
  
  ],exports :[
    RenderingPermissionsDirective
  ]
})
export class PermissionsModule { }
